import { MouseEventHandler } from "react";
import styled from "@emotion/styled";

const ButtonComponent = styled.button`
  position: relative;
  display: inline-flex;
  vertical-align: top;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-style: normal;
  font-family: "Red Hat Text", sans-serif;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  border: 2px solid transparent;
  border-radius: 8px;
  white-space: nowrap;
  transition: all .15s ease-in-out;

  [icon] {
    font-size: 12px;
    line-height: 1;
  }

  > span {
    display: inline-flex;
    line-height: 1;
  }
  
  &.loading {
    cursor: default;
    pointer-events: none;

    &::after {
      box-sizing: border-box;
      content: "";
      position: absolute;
      border-radius: 100%;
      left: 50%;
      top: 50%;
      width: 0px;
      height: 0px;
      margin: -10px 0 0 -10px;
      border: 3px solid rgba(255,255,255, 0.5);
      border-left-color: #FFF;
      border-top-color: #FFF;
      animation: spin .6s infinite linear, grow .3s forwards ease-out;
    }
  }

  &.disabled,
  &[disabled] {
    cursor: not-allowed;
    opacity: 0.3;
    pointer-events: none;
  }

  @media (max-width: 767px){
    border-radius: 12px;
  }
  
  @keyframes spin { 
    to {
        transform: rotate(359deg);
    }
  }

  @keyframes grow { 
    to {
        width: 20px;
        height: 20px;
    }
  }
  
  &.kompare-ui-btn-sm {
    padding: 8px 14px;
    font-size: 14px;
    line-height: 16px;
  
    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 18px;
      padding-top: 9px;
      padding-bottom: 9px;
    }
  }
  
  &.kompare-ui-btn-md {  
    padding: 9px 16px;
    font-size: 16px;
    line-height: 18px;
  
    @media (max-width: 767px) {
      font-size: 18px;
      line-height: 20px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
  
  &.kompare-ui-btn-lg {
    padding: 10px 18px;
    font-size: 18px;
    line-height: 20px;
  
    @media (max-width: 767px) {
      padding-top: 15px;
      padding-bottom: 15px;
    }
  }
  
  &.kompare-ui-btn-xl {
    padding: 12px 20px;
    font-size: 18px;
    line-height: 20px;
  
    @media (max-width: 767px) {
      padding-top: 15px;
      padding-bottom: 15px;
    }
  }
  
  &.kompare-ui-btn-primary {
    color: #FFF !important;
    background-color: #6A0098;
    border-color: #6A0098;

    > span svg path{
      fill: #FFF;
    }
  
    &:not(.disabled):not([disabled]) {
      &:hover{
        background-color: #8E00CC;
        border-color: #8E00CC;
      }
  
      &:focus {
        background-color: #B200FF;
        border-color: #B200FF;
      }
  
      &:active {
        background-color: #470066;
        border-color: #6A0098;
      }
    }
  }
  
  &.kompare-ui-btn-outline-primary {
    color: #6A0098;
    background-color: transparent;
    border-color: #6A0098;

    > span svg path{
      fill: #6A0098;
    }
  
    &:not(.disabled):not([disabled]) {
      &:hover{
        color: #FFF;
        background-color: #8E00CC;
        border-color: #8E00CC;

        > span svg path{
          fill: #FFF;
        }
      }
  
      &:focus {
        color: #FFF;
        background-color: #B200FF;
        border-color: #B200FF;

        > span svg path{
          fill: #FFF;
        }
      }
  
      &:active {
        color: #470066;
        background-color: transparent;
        border-color: #470066;

        > span svg path{
          fill: #470066;
        }
      }
    }
  
    &.loading::after {
      border-color: rgba(106,0,152, 0.5);
      border-left-color: #6A0098;
      border-top-color: #6A0098;
    }
  }
  
  &.kompare-ui-btn-text-primary {
    color: #6A0098;
    background-color: transparent !important;
    border-color: transparent !important;
    padding-left: 0;
    padding-right: 0;

    > span svg path{
      fill: #6A0098;
    }
  
    &:not(.disabled):not([disabled]) {
      &:hover{
        color: #8E00CC;

        > span svg path{
          fill: #8E00CC;
        }
      }
  
      &:focus {
        

        > span svg path{
          
        }
      }
  
      &:active {
        color: #470066;

        > span svg path{
          fill: #470066;
        }
      }
    }
  
    &.loading::after {
      border-color: rgba(106,0,152, 0.5);
      border-left-color: #6A0098;
      border-top-color: #6A0098;
    }
  }
  
  &.kompare-ui-btn-secondary {
    color: #FFF !important;
    background-color: #F4910F;
    border-color: #F4910F;

    > span svg path{
      fill: #FFF;
    }
  
    &:not(.disabled):not([disabled]) {
      &:hover{
        background-color: #F6A850;
        border-color: #F6A850;
      }
  
      &:focus {
        background-color: #F9C081;
        border-color: #F9C081;
      }
  
      &:active {
        background-color: #D6760B;
        border-color: #D6760B;
      }
    }
  }
  
  &.kompare-ui-btn-outline-secondary {
    color: #F4910F;
    background-color: transparent;
    border-color: #F4910F;

    > span svg path{
      fill: #F4910F;
    }
  
    &:not(.disabled):not([disabled]) {
      &:hover{
        color: #FFF;
        background-color: #F6A850;
        border-color: #F6A850;

        > span svg path{
          fill: #FFF;
        }
      }
  
      &:focus {
        color: #FFF;
        background-color: #F9C081;
        border-color: #F9C081;

        > span svg path{
          fill: #FFF;
        }
      }
  
      &:active {
        color: #D6760B;
        background-color: transparent;
        border-color: #D6760B;

        > span svg path{
          fill: #D6760B;
        }
      }
    }
  
    &.loading::after {
      border-color: rgba(244,145,15, 0.5);
      border-left-color: #F4910F;
      border-top-color: #F4910F;
    }
  }
  
  &.kompare-ui-btn-text-secondary {
    color: #F4910F;
    background-color: transparent !important;
    border-color: transparent !important;
    padding-left: 0;
    padding-right: 0;

    > span svg path{
      fill: #F4910F;
    }
  
    &:not(.disabled):not([disabled]) {
      &:hover{
        color: #F6A850;

        > span svg path{
          fill: #F6A850;
        }
      }
  
      &:focus {
        color: #F9C081;

        > span svg path{
          fill: #F9C081;
        }
      }
  
      &:active {
        color: #D6760B;

        > span svg path{
          fill: #D6760B;
        }
      }
    }
  
    &.loading::after {
      border-color: rgba(244,145,15, 0.5);
      border-left-color: #F4910F;
      border-top-color: #F4910F;
    }
  }
  
  &.kompare-ui-btn-black {
    color: #FFF !important;
    background-color: #323232;
    border-color: transparent !important;

    > span svg path{
      fill: #FFF;
    }
  
    &:not(.disabled):not([disabled]) {
      &:hover{
        background-color: #666;
      }
  
      &:focus {
        background-color: #999;
      }
  
      &:active {
        background-color: #000;
      }
    }
  
    &.loading::after {
      border-color: rgba(255,255,255, 0.5);
      border-left-color: #FFF;
      border-top-color: #FFF;
    }
  }
  
  &.kompare-ui-btn-outline-black {
    color: #323232;
    background-color: transparent !important;
    border-color: #4D4D4D;

    > span svg path{
      fill: #323232;
    }
  
    &:not(.disabled):not([disabled]) {
      &:hover{
        color: #8E00CC;
        border-color: #8E00CC;

        > span svg path{
          fill: #8E00CC;
        }
      }
  
      &:focus {
        color: #B200FF;
        border-color: #B200FF;

        > span svg path{
          fill: #B200FF;
        }
      }
  
      &:active {
        color: #470066;
        border-color: #470066;

        > span svg path{
          fill: #470066;
        }
      }
    }
  
    &.loading::after {
      border-color: rgba(0,0,0, 0.5);
      border-left-color: #000;
      border-top-color: #000;
    }
  }
  
  &.kompare-ui-btn-text-black {
    color: #323232;
    background-color: transparent !important;
    border-color: transparent !important;
    padding-left: 0;
    padding-right: 0;

    > span svg path{
      fill: #323232;
    }
  
    &:not(.disabled):not([disabled]) {
      &:hover{
        color: #8E00CC;

        > span svg path{
          fill: #8E00CC;
        }
      }
  
      &:focus {
        color: #B200FF;

        > span svg path{
          fill: #B200FF;
        }
      }
  
      &:active {
        color: #470066;

        > span svg path{
          fill: #470066;
        }
      }
    }
  
    &.loading::after {
      border-color: rgba(0,0,0, 0.5);
      border-left-color: #000;
      border-top-color: #000;
    }
  }
  
  &.kompare-ui-btn-outline-white {
    color: #FFF;
    background-color: transparent !important;
    border-color: #FFF;

    > span svg path{
      fill: #FFF;
    }
  
    &:not(.disabled):not([disabled]) {
      &:hover{
        color: #F6A850;
        border-color: #F6A850;

        > span svg path{
          fill: #F6A850;
        }
      }
  
      &:focus {
        color: #F9C081;
        border-color: #F9C081;

        > span svg path{
          fill: #F9C081;
        }
      }
  
      &:active {
        color: #D6760B;
        border-color: #D6760B;

        > span svg path{
          fill: #D6760B;
        }
      }
    }
  
    &.loading::after {
      border-color: rgba(255,255,255, 0.5);
      border-left-color: #FFF;
      border-top-color: #FFF;
    }
  }
  
  &.kompare-ui-btn-text-white {
    color: #FFF;
    background-color: transparent !important;
    border-color: transparent !important;
    padding-left: 0;
    padding-right: 0;

    > span svg path{
      fill: #FFF;
    }
  
    &:not(.disabled):not([disabled]) {
      &:hover{
        color: #F6A850;

        > span svg path{
          fill: #F6A850;
        }
      }
  
      &:focus {
        color: #F9C081;

        > span svg path{
          fill: #F9C081;
        }
    }
  
      &:active {
        color: #D6760B;

        > span svg path{
          fill: #D6760B;
        }
      }
    }
  
    &.loading::after {
      border-color: rgba(255,255,255, 0.5);
      border-left-color: #FFF;
      border-top-color: #FFF;
    }
  }

  &.btnBlock {
    width: 100%;

    & + & {
      margin-top: 8px;
    }
  }
`;

const sizeMapper = {
  xsmall: "xs",
  small: "sm",
  medium: "md",
  large: "lg",
  extralarge: "xl",
} as const;
export type ButtonSize = keyof typeof sizeMapper;

const typeMapper = {
  primary: "kompare-ui-btn-primary",
  secondary: "kompare-ui-btn-secondary",
  black: "kompare-ui-btn-black",
  outlinePrimary: "kompare-ui-btn-outline-primary",
  outlineSecondary: "kompare-ui-btn-outline-secondary",
  outlineBlack: "kompare-ui-btn-outline-black",
  outlineWhite: "kompare-ui-btn-outline-white",
  textPrimary: "kompare-ui-btn-text-primary",
  textSecondary: "kompare-ui-btn-text-secondary",
  textBlack: "kompare-ui-btn-text-black",
  textWhite: "kompare-ui-btn-text-white",
};

export type ButtonType = keyof typeof typeMapper;

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  size?: ButtonSize;
  btnType?: ButtonType;
  disabled?: boolean;
  loading?: boolean;
  iconPosition?: "left" | "right";
  onClick?: MouseEventHandler<HTMLButtonElement>;  
}

export const Button: React.FC<ButtonProps> = ({
  text,
  size = "large",
  btnType = "primary",
  disabled,
  loading,
  iconPosition = "right",
  onClick,
  ...props
}) => {
  const type = typeMapper[btnType];
  const sizeValue = `kompare-ui-btn-${sizeMapper[size]}`;
  const disabledValue = disabled ? "disabled" : "";
  const isLoading = loading ? "loading" : "";

  const className = `${sizeValue} ${type} ${disabledValue} ${isLoading} ${props.className || ""}`;

  const style = {
    ...props.style,
  };
  return (
    <ButtonComponent
      {...props}
      onClick={onClick}
      style={style}
      className={className}
    >
      {iconPosition === "left" && props.children}
      {text}
      {iconPosition === "right" && props.children}
    </ButtonComponent>
  );
};
